// Where the fallback VAT rate comes from on the client.
//
// A branch carries its own `vat_rate` and that always wins. This module answers
// the other question: what rate applies when a branch has none. That used to be
// a bare `7` repeated across every screen that priced anything; it now comes
// from REACT_APP_VAT_RATE, so a deployment under a different tax regime is a
// config change rather than a code change.
//
// React inlines REACT_APP_* at BUILD time, so changing it means rebuilding the
// app — the same rule REACT_APP_API_URL already follows. Keep it in step with
// the API's own VAT_RATE: the server freezes rates onto saved records, and this
// value only previews what the server will decide.
//
// The 7 below is the last-resort default for a build that never set the
// variable — Thailand's rate, which is what this system shipped with.
const FALLBACK_VAT_RATE = 7;

function readEnvRate() {
  const raw = process.env.REACT_APP_VAT_RATE;
  if (raw === undefined || String(raw).trim() === '') return FALLBACK_VAT_RATE;
  const n = Number(raw);
  // A typo'd 700 must not price the whole screen at 700% VAT.
  if (!Number.isFinite(n) || n < 0 || n > 100) return FALLBACK_VAT_RATE;
  return n;
}

export const DEFAULT_VAT_RATE = readEnvRate();

// The rate that applies to a branch. A stored 0 is a real 0% branch and must
// survive; only a missing/NULL/unparsable rate inherits the default.
export function branchVatRate(branch) {
  const raw = branch?.vat_rate;
  if (raw === null || raw === undefined || raw === '') return DEFAULT_VAT_RATE;
  const n = Number(raw);
  return Number.isFinite(n) ? n : DEFAULT_VAT_RATE;
}
